var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseWrapper',[_c('div',{staticClass:"grid grid-cols-1 md:grid-cols-2"},[(_vm.checkHasPermission('users.read_login_stats'))?_c('LoginStats'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }